import React, { useEffect, useState } from "react";
import { Table, TableContainer } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";

import { AdminCreateLaborDialog } from "../../dialogs";
import { setIsOpenDialog } from "../../redux";

import { WorkOrderRoutingHeader } from "./WorkOrderRoutingHeader";
import WorkOrderRoutingTableBody from "./WorkOrderRoutingTableBody";

const WorkOrderRoutingTable = ({
  _setIsOpenDialog = () => {},
  showQuantity = false,
  ...props
}) => {
  const { watch } = useFormContext();
  const instructions = watch("instructions");
  const routing = instructions?.flatMap((ins, idx) =>
    ins.routing?.map((r, irx) => ({
      prefix: `instructions.${idx}.routing.${irx}`,
      ...r,
    })),
  );

  const [routeId, setRouteId] = useState(null);
  const [editId, setEditId] = useState(null);

  const handleOpen = (val = true) =>
    _setIsOpenDialog("admin-create-labor-ticket", val);
  const handleClose = () => {
    handleOpen(false);
    setRouteId(null);
  };

  useEffect(() => {
    if (routeId) handleOpen(true);
  }, [routeId]);

  return (
    <>
      <TableContainer>
        <Table id="CompaniesTable">
          <WorkOrderRoutingHeader showQuantity={showQuantity} />
          <WorkOrderRoutingTableBody
            setEditId={setEditId}
            setRouteId={setRouteId}
            editId={editId}
            fields={routing}
            showQuantity={showQuantity}
            {...props}
          />
        </Table>
      </TableContainer>
      <AdminCreateLaborDialog routeId={routeId} onClose={handleClose} />
    </>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export const WorkOrderRoutingTableV2 = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkOrderRoutingTable);
export default WorkOrderRoutingTableV2;
